import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const inviteToGroup = createAsyncThunk<
  void,
  { groupId: string; telegramIds: number[] },
  { state: RootState }
>('groups/invite', async ({ groupId, telegramIds }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const group = await groupsService.inviteToGroup({
      groupId,
      telegramIds,
    });
    dispatch(entitiesActions.upsertGroup(group));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось пригласить участников';
    throw error;
  }
});
